import { CalcRowDimensionInputController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Represents a component for handling dimension input in a calculation row.
 * @example
 * ```html
 * <salaxy-calc-row-dimension-input></salaxy-calc-row-dimension-input>
 * ```
 */
export class CalcRowDimensionInput extends ComponentBase {
   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Currently edited row */
      row: "<",
      /** Dimension definition. */
      definition: "<",
      /** Possible inherited dimensions values from upper lever (e.g. calc level to rows) */
      inherited: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Style of the inputs.
       * Supports empty or 'openClose'. Only available when not readOnly
       */
      inputMode: "@",
    };

    /** Uses the CalcRowDimensionInputController */
    public controller = CalcRowDimensionInputController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/rows/CalcRowDimensionInput.html";

}
